import { TAiAnalyticsActions } from './ai-analytics.actions';
import { TAiAnalyticsState, TAiAnalyticsActionType } from './ai-analytics.models';

export const intialState: TAiAnalyticsState = {
  chatUiModel: null,
  lastSeparatorText: null,
};

export function aiAnalyticsReducer(state = intialState, action: TAiAnalyticsActions): TAiAnalyticsState {
  switch (action.type) {
    case TAiAnalyticsActionType.SetAiAnalyticsChatUiModel:
      return {
        ...state,
        chatUiModel: action.payload,
      };
    case TAiAnalyticsActionType.SetAiAnalyticsLastSeparatorText:
      return {
        ...state,
        lastSeparatorText: action.payload,
      };
    default:
      return state;
  }
}
